export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Pending"] = "Pending";
    PaymentStatus["Processing"] = "Processing";
    PaymentStatus["Succeeded"] = "Succeeded";
    PaymentStatus["Failed"] = "Failed";
    PaymentStatus["Canceled"] = "Canceled";
})(PaymentStatus || (PaymentStatus = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["Cards"] = "Cards";
    PaymentType["SepaDirectDebit"] = "SepaDirectDebit";
    PaymentType["PayPal"] = "PayPal";
    PaymentType["PaymentRequest"] = "PaymentRequest";
})(PaymentType || (PaymentType = {}));
export var ErrorCode;
(function (ErrorCode) {
    // Payee
    ErrorCode["InvalidPayee"] = "E400101";
    ErrorCode["PayeeNotConfiguredForStripe"] = "E400202";
    ErrorCode["PayeeNotConfiguredForPayPal"] = "E400203";
    ErrorCode["PayeeRetrieveError"] = "E404141";
    // Payer
    ErrorCode["InvalidPayer"] = "E400201";
    ErrorCode["PayerRetrieveError"] = "E404201";
    ErrorCode["PayerSaveMethodError"] = "E500262";
    // Payment
    ErrorCode["InvalidMinimumAmount"] = "E400301";
    ErrorCode["InvalidEmail"] = "E400302";
    ErrorCode["PaymentUseStoredMethodError"] = "E400361";
    ErrorCode["PaymentRetrieveError"] = "E404341";
    ErrorCode["PaymentCreationError"] = "E500351";
    ErrorCode["PaymentCreateStripeMethodError"] = "E500371";
    ErrorCode["PaymentCreatePayPalMethodError"] = "E500381";
    ErrorCode["PaymentCapturePayPalError"] = "E500382";
})(ErrorCode || (ErrorCode = {}));
//# sourceMappingURL=types.js.map